module.exports = __webpack_public_path__ + "static/media/replacing-django-with-react.f502f2a5.md";